<template>
  <div style="height: 100%; position: relative">
    <ul id="videoNav">
      <Dropdown>
        <Button type="text">画面展示</Button>
        <DropdownMenu slot="list">
          <DropdownItem v-for="(item, index) in pages" :key="index"
            ><p @click="mySetPlayerNum(item)" style="padding: 6px 0">
              画面×{{ item }}
            </p></DropdownItem
          >
        </DropdownMenu>
      </Dropdown>
      <Button type="text" @click="openSetPages = true">通道设置</Button>

      <Button type="text" @click="setScreen()">{{
        $store.state.isMapScreen ? "退出全屏" : "铺满全屏"
      }}</Button>
      <Button
        icon="md-add"
        type="text"
        @click="openControl = true"
        :disabled="true"
        >云控制台</Button
      >
      <!-- <li @click="openControl = true">云台</li> -->
    </ul>
    <div id="bVideo-wrap">
      <div id="bVideo"></div>
    </div>
    <Modal
      v-model="openControl"
      title="云台控制"
      draggable
      footer-hide
      width="240"
      :mask="false"
    >
      <control></control>
    </Modal>
    <Modal
      v-model="openSetPages"
      title="设置单台车播放通道数量"
      draggable
      width="400"
      @on-ok="setPages"
    >
      <p style="margin-bottom:20px;">请先关掉所有画面后再设置通道数量</p>
      <RadioGroup v-model="tongdaoNum">
        <Radio :label="1">1路</Radio>
        <Radio :label="2">2路</Radio>
        <Radio :label="3">3路</Radio>
        <Radio :label="4">4路</Radio>
        <Radio :label="5">5路</Radio>
        <Radio :label="6">6路</Radio>
      </RadioGroup>
    </Modal>
  </div>
</template>
<script>
import control from "./control";
let playList = [];
let player = null;
let allChannelArr = [];
let tidObj=null;
export default {
  components: { control },
  data() {
    return {
      videoModal: false,
      isPlay: true,
      deviceNo: "13878998877",
      openControl: false,
      arr: [
        {
          name: 111,
          children: [{ name: 222, children: [{ name: 444 }] }],
        },
        {
          name: 555,
          children: [
            {
              name: 666,
              children: [{ name: 777 }],
            },
          ],
        },
      ],
      pages: [1, 2, 4, 6, 8, 9, 13, 16, 17, 25],
      tongdao: [1, 2, 3, 4],
      tongdaoNum: 4,
      openSetPages: false,
    };
  },
  methods: {
    beforCcreatePlayer() {
      this.videoModal = true;
      if (player != null) {
        player.destroy();
        player = null;
        playList = [];
        tidObj = null;
        this.videoModal = false;
        setTimeout(() => {
          this.videoModal = true;
          this.isPlay = true;
          setTimeout(() => {
            this.createPlayer();
          }, 100);
        }, 100);
      } else {
        setTimeout(() => {
          this.createPlayer();
        }, 100);
      }
    },
    createPlayer() {
      var that = this;
      player = new byskplayer({
        id: "bVideo", //容器
        baseURL: "wss://videostream.car900.com/", //路径
        //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
        // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
        userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
        //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
        isReal: true, //是否实时
        isRecord: false, //是否回放
        userId: "apidemo", //用户id,
        click: this.onPlayClick,
        playstart: this.onPlayStart,
        playend: this.onPlayEnd,
        isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
      });
      //player.poster = that.lycsr.vbg; //设置预览图片
      this.mySetPlayerNum(16); //设置视频画面
    },
    mySetPlayerNum(t) {
      player.setPlayerNum(t);
    },
    onPlayClick(e) {
      // console.log(e);
      //alert(e);
    },
    open(deviceNo, now) {
      this.deviceNo = deviceNo;
      let device = deviceNo;
      let channel = 1;
      let protocolType = 1;
      let obj = playList.find(
        (p) => p.device == device && p.channel == channel
      );
      if (obj) return; //已经在播放的则不能再播放

      //const channelArr123 = channel.split(",").map(p => p * 1);
      // console.log(channelArr123);
      // const channelArr = [1, 2, 3, 4];
      allChannelArr.push(now);
      //allChannelArr=[now]
      const channelArr = this.tongdao;
      const tidObj = player.allocate(channelArr.length); //根据通道数申请
      // let tidObj = player.allocate(1); //申请一个视频播放器
      if (tidObj.flag == 1) {
        //申请成功
        let params = {
          device: device, //终端号
          channel: channel, //通道号 （1~8）
          protocolType: protocolType, //协议类型，1：GF-1078，GB-1078; 2：GA系列
          codeTypeCtrlBtnEnabled: protocolType === 1, //是否显示高标清切换按钮(GF才有高清)
        };

        if (protocolType === 1) {
          //1078
          for (let i = 0; i < channelArr.length; i++) {
            const tid = tidObj.ids[i];
            const param = {
              ...params,
              channel: channelArr[i],
            };
            player.real.open(tid, param, (res) => {
              // console.log(res);
              this.isPlay = false;
            });
            playList.push({
              ...param,
            });
          }
        } else if (protocolType === 2) {
          //GA
          player.real.open(tidObj.ids, params, (res) => {
            // console.log(res);
            this.isPlay = false;
          });
          playList.push(
            ...tidObj.ids.map((p, i) => {
              return {
                ...params,
                channel: channelArr[i],
              };
            })
          );
        }
      } else {
        //申请失败
        alert(tidObj.msg);
      }
    },
    pause(deviceNo, now) {
      let device = deviceNo;
      let channel = 1;
      //const channelArr = channel.split(",").map(p => p * 1);
      //const channelArr = [channel];
      const channelArr = this.tongdao;
      for (let i = 0; i < channelArr.length; i++) {
        let index = playList.findIndex(
          (p) => p.device == device && p.channel == channelArr[i]
        );
        let obj = playList[index];
        if (obj)
          player.real.close(
            obj.tid,
            {
              device: obj.device,
              channel: obj.channel,
              protocolType: obj.protocolType,
            },
            (res) => {
              this.isPlay = true;
            }
          );
        playList.splice(index, 1);
      }
    },
    onPlayStart(e) {
      this.isPlay = false;
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      let obj = playList[index];
      if (obj) return;
      playList.push({
        ...e,
      });
    },
    onPlayEnd(e) {
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      playList.splice(index, 1);
    },
    //断开连接
    close() {
      player.destroy();
      player = null;
      playList = [];
      tidObj = null;
      this.isPlay = true;
      this.$emit("closeVideo");
      this.videoModal = false;
    },
    dasf() {
      this.$Message.info("即将开放，敬请期待");
    },
    //视频满屏
    setScreen() {
      this.$store.state.isMapScreen = !this.$store.state.isMapScreen;
    },
    setPages() {
      this.tongdao = [];
      for (let i = 1; i <= this.tongdaoNum; i++) {
        this.tongdao.push(i);
      }
    },
  },
  created() {
    this.beforCcreatePlayer();
  },
  mounted() {
    // player.setPlayerNum(4)
  },
  destroyed() {
    this.close();
  },
};
</script>
<style lang="">
#videoNav {
  width: 100%;
  height: 40px;
  background: #fff;
  line-height: 40px;
}
#videoNav li {
  padding: 0 0 0 20px;
  float: left;
  cursor: pointer;
}
#videoNav li:hover {
  color: red;
}
#bVideo-wrap {
  background: #ccc;
  height: calc(100% - 50px);
  width: 100%;
}
/* #bVideo .bysk-p-layout-view .layout-4 .num {
  position: absolute !important;
  left: auto !important;
  margin-bottom: 2px;
  outline: solid 8px #fff;
  width: auto;
  height: auto;
} */
</style>


// WEBPACK FOOTER //
// src/components/video/video.vue